import React from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

const Row100 = props => {
  const { item, openArrangement } = props;

  const params = {
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  const newArr = item.filter(item => typeof item.id !== 'string');

  return (
    <Swiper {...params} containerClass="swiper-container masonry__span">
      {newArr.map(el =>
        el.id !== 'start-configuration' || el.id !== 'accessories-shop' ? (
          <div
            key={el.id}
            style={{ backgroundImage: `url(${el.images}) ` }}
            onClick={() => openArrangement(el.id)}>
            <span>{el.title}</span>
            <div className="masonry__tile-button">
              OTWÓRZ <i className="icon-small-arrow"></i>
            </div>
          </div>
        ) : null,
      )}
    </Swiper>
  );
};

export default Row100;
